import React, { FC } from 'react'

import {
  Input,
  Picker,
  Row,
  Select,
  Span,
  Form,
  Button,
  Grid,
  Text
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { SPACING, COLORS } from 'utils'
import { usePersistForm } from 'hooks'
// import { Container } from './styles';

export interface IFieldsFilterJobs {
  NmFornecedor: string
  DtEnvioInicio?: any
  DtEnvioFim?: any
  NmTipoJOB: string
}

export interface IFilterJobsProps {
  handleOnClickClearButton: () => void
  handleSubmitForm: any
  tipos: any
}

const FiltersJobs: FC<IFilterJobsProps> = ({
  handleSubmitForm,
  tipos,
  handleOnClickClearButton
}) => {
  const {
    control,
    watch,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm<IFieldsFilterJobs>()

  usePersistForm('ngt_search_jobs', {
    setValue,
    watch
  })

  const selectValue = watch('NmTipoJOB')
  const dtInicio = watch('DtEnvioInicio')
  const dtFim = watch('DtEnvioFim')

  return (
    <Form
      onSubmit={handleSubmit(handleSubmitForm)}
      marginTop={SPACING.spacing10}
    >
      <Grid
        gridCols="2fr 1fr 0.1fr 1fr 3.5fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`0 0 ${SPACING.spacing20} 0`}
      >
        <Input
          defaultValue={''}
          label="Fornecedor"
          placeholder="Nome Fornecedor"
          formValue="NmFornecedor"
          control={control}
        />
        <Picker
          maxDate={moment(dtFim)}
          defaultValue={null}
          label="Data de Envio"
          control={control}
          formValue="DtEnvioInicio"
        />
        <Span text="à" marginTop={SPACING.spacing30} />
        <Picker
          minDate={moment(dtInicio)}
          formValue="DtEnvioFim"
          control={control}
          defaultValue={null}
        />
      </Grid>

      <Grid
        gridCols="2fr 2fr 1.5fr 1fr 1fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`0 0 ${SPACING.spacing10} 0`}
      >
        <Input
          defaultValue={''}
          formValue="NmContraparte"
          control={control}
          label="Contraparte"
          placeholder="Nome do Contraparte"
        />
        <Select
          defaultValue={null}
          onChange={(e) => {
            setValue('NmTipoJOB', e.target.value)
          }}
          value={selectValue}
          valueMenu=""
          labelMenu=""
          listOptions={tipos}
          clearSelect
          clearSelectValue={''}
          errors={errors}
          label="Tipo"
          formValue="NmTipoJOB"
        />
        <Text></Text>
        <Button
          onClick={() => {
            reset()
            handleOnClickClearButton()
          }}
          text="Limpar"
        />
        <Button
          endIcon={<MagnifyingGlassIcon />}
          type="submit"
          text="Pesquisar"
        />
      </Grid>
    </Form>
  )
}

export default FiltersJobs
